import React from 'react';
import { Link } from 'react-router-dom';
import ContactMe from '../../components/ContactMe/ContactMe';
import Header from '../../components/Header/Header';
import Projects from '../../components/Projects/Projects';
import Services from '../../components/Services/Services';
import Footer from '../../components/Shared/Footer/Footer';
import Skills from '../../components/Skills/Skills';

const Home = () => {
    return (
        <div id='home'>
            <Header></Header>
            <Skills></Skills>
            <div>
                <Projects></Projects>
                <div>
                    <Link to='/projects'>
                        <button className='px-6 py-2 rounded-3xl mt-6 mb-3 md:mt-10 git-button'>More projects</button>
                    </Link>
                </div>
            </div>
            <Services></Services>
            <ContactMe></ContactMe>
            <Footer></Footer>
        </div>
    );
};

export default Home;